module.exports = __webpack_public_path__ + "img/HC_HC-DIST.c94c777c.png";